import { useRouter } from 'next/router';
import { getQueryStringsFromUrl } from '@packages/shared';
import { logger, useConfig } from '@packages/utilities';
import { getUrlParameters } from '../../helpers/getUrlParameters';
import type { HashDataObject } from '../../types/HashDataObject';

export const useHashParameters = (forcePreselect: boolean = false): HashDataObject => {
  const { asPath } = useRouter();
  const {
    product: { usePrintPromo },
  } = useConfig();

  try {
    const { hash, search } = getQueryStringsFromUrl(asPath);

    return getUrlParameters(hash, search, forcePreselect, usePrintPromo);
  } catch (error) {
    logger.error(error);

    return {
      isPreselectedDimension: forcePreselect,
    };
  }
};
